import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { LOGO_URL } from "@/lib/constants";

const links = [
  { href: "#traditions", label: "Traditions" },
  { href: "#events", label: "Events" },
  { href: "#desserts", label: "Desserts" },
  { href: "#about", label: "About" },
  { href: "#faq", label: "FAQ" },
];

export default function Nav() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${
        scrolled
          ? "bg-[hsl(var(--cream))]/90 backdrop-blur-md border-b border-[hsl(var(--rose)/0.3)]"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-3 sm:px-8 lg:px-12">
        <a
          href="#top"
          data-testid="nav-logo"
          className="flex items-center gap-2.5"
        >
          <img
            src={LOGO_URL}
            alt="Heritage Table Catering logo"
            className="h-12 w-12 sm:h-14 sm:w-14 object-contain"
          />
          <div className="hidden sm:block leading-tight">
            <div className="font-serif-display text-lg text-[hsl(var(--brown))]">
              Heritage Table
            </div>
            <div className="text-[10px] tracking-[0.32em] text-[hsl(var(--sage-deep))] font-semibold">
              CATERING
            </div>
          </div>
        </a>

        <nav className="hidden md:flex items-center gap-7">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-sm font-medium text-[hsl(var(--brown-soft))] hover:text-[hsl(var(--rose-deep))] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="#quote"
          data-testid="nav-quote-cta"
          className="btn-pill btn-primary hidden md:inline-flex text-xs"
        >
          Request Quote
        </a>

        <button
          onClick={() => setOpen((v) => !v)}
          data-testid="nav-menu-toggle"
          aria-label="Open menu"
          className="md:hidden rounded-full border border-[hsl(var(--rose)/0.5)] p-2 text-[hsl(var(--brown))]"
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="md:hidden border-t border-[hsl(var(--rose)/0.3)] bg-[hsl(var(--cream))]/95 backdrop-blur-md"
        >
          <div className="flex flex-col gap-1 px-6 py-4">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="py-2 text-sm font-medium text-[hsl(var(--brown-soft))]"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#quote"
              onClick={() => setOpen(false)}
              data-testid="nav-mobile-quote-cta"
              className="btn-pill btn-primary mt-2 self-start text-xs"
            >
              Request Quote
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
